import { render, staticRenderFns } from "./WhiteList.vue?vue&type=template&id=478010cf&scoped=true&"
import script from "./WhiteList.vue?vue&type=script&lang=js&"
export * from "./WhiteList.vue?vue&type=script&lang=js&"
import style0 from "./WhiteList.vue?vue&type=style&index=0&id=478010cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478010cf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VPagination,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478010cf')) {
      api.createRecord('478010cf', component.options)
    } else {
      api.reload('478010cf', component.options)
    }
    module.hot.accept("./WhiteList.vue?vue&type=template&id=478010cf&scoped=true&", function () {
      api.rerender('478010cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Store/WhiteList.vue"
export default component.exports